// Third-party
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

// Components
import DataTable from '@/views/components/data/DataTable';

// Types
import { DataUploadPortalConfig, DataUploadPortalLog } from '@/types/data-upload-config';
import Locale from '@/types/locale';
import { ReduxState } from '@/redux/modules/types';

// Utils
import { FormattedMessage, formatMessageWithLocale } from '@/utils/i18n';

type Props = {
  config: DataUploadPortalConfig;
  locale?: Locale;
};

const ErrorLogTable: React.FC<Props> = (props: Props) => {
  const { config, locale } = props;

  const getColumns = () => [
    {
      key: 'type',
      accessor: 'type',
      width: 83,
      Header: () => <FormattedMessage id="Admin.DataUpload.ErrorLog.Type" locale={locale} />,
      Cell: ({ value }: { value: string }) =>
        value ? (
          <span className={`type ${value}`}>
            <FormattedMessage id={`Admin.DataUpload.ErrorLog.${value}`} locale={locale} />
          </span>
        ) : null,
    },
    {
      key: 'description',
      accessor: 'description',
      width: 220,
      Header: () => <FormattedMessage id="Admin.DataUpload.ErrorLog.Description" locale={locale} />,
      Cell: ({ value }: { value: string }) => (value ? <span className="description">{value}</span> : null),
    },
    {
      key: 'time',
      accessor: 'time',
      width: 120,
      Header: () => <FormattedMessage id="Admin.DataUpload.ErrorLog.Time" locale={locale} />,
      Cell: ({ value }: { value: string }) => {
        const date = moment(value).format(formatMessageWithLocale('Common.DateFormats.Short', locale));
        const time = moment(value).format('HH:mm:ss A');
        return value ? (
          <p className="time">
            <span>{date}</span>
            <span>{time}</span>
          </p>
        ) : null;
      },
    },
    {
      key: 'source',
      accessor: 'source',
      width: 200,
      Header: () => <FormattedMessage id="Admin.DataUpload.ErrorLog.Source" locale={locale} />,
      Cell: ({ value }: { value: string }) => (value ? <span className="source">{value}</span> : null),
    },
  ];

  const getTableData = (config: DataUploadPortalConfig) => {
    const { dataUpload } = config;
    if (!dataUpload || !dataUpload.validationLog) {
      return [];
    }

    return dataUpload.validationLog.map((item: DataUploadPortalLog) => ({
      type: item.level,
      description: item.message,
      time: item.at,
      source: item.context?.[0],
    }));
  };

  return <DataTable className="group-data-jobs data-upload-table" columns={getColumns()} data={getTableData(config)} />;
};

const mapStateToProps = (state: ReduxState) => ({
  locale: state.intl.locale,
});

export default connect(mapStateToProps, {})(ErrorLogTable);
